import { setDefaultStyle } from "apparatus/draw";
import { Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
import { addEdgeLips, smoothCorner } from "../draw";
export class ThieleTube {
    render(appearance) {
        let outer = new Path(Segments([[0, 0]], [[0, 130], undefined, [3, 15]], [[30, 130], [-10, 5]], [[100, 90]], [[25, 50]], [[25, 0]]));
        smoothCorner(outer.segments[3], 30.0);
        addEdgeLips(outer);
        let inner = new Path(Segments([[25, 62]], [[80, 90]], [[25, 118]]));
        inner.closePath();
        smoothCorner(inner.segments[1], 15.0);
        let tube = outer.subtract(inner);
        // Scale everything.
        const pivot = tube.bounds.center;
        tube.scale(appearance.scale, pivot);
        outer.scale(appearance.scale, pivot);
        inner.scale(appearance.scale, pivot);
        let hitShape = outer.clone();
        let liquidMask = tube;
        const graphic = new Group([inner, outer]);
        setDefaultStyle(graphic);
        return { graphic, hitShape, liquidMask };
    }
}
ThieleTube.properties = {
    label: "Thiele Tube",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: {
        scale: 1.0,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 0.7, max: 1.5, step: 0.05, unit: "%"
        }
    ],
};
